'use client';

import { useEffect, useMemo, useRef } from 'react';
import { useLocale, usePathname } from '@/i18n/routing';
import { getTaskHistoryRouteContext } from './utils';

export function useTaskHistoryRouteContext() {
  const pathname = usePathname();
  const locale = useLocale();
  const stableCreatePathnameRef = useRef(pathname);

  useEffect(() => {
    if (!pathname.startsWith('/creation-detail/')) {
      stableCreatePathnameRef.current = pathname;
    }
  }, [pathname]);

  const createPathname = pathname.startsWith('/creation-detail/') ? stableCreatePathnameRef.current : pathname;
  const taskHistoryRouteContext = useMemo(
    () => getTaskHistoryRouteContext(createPathname, locale),
    [createPathname, locale],
  );

  return {
    createPathname,
    ...taskHistoryRouteContext,
  };
}
